import { render, staticRenderFns } from "./MenuPrincipal.vue?vue&type=template&id=0e38861e&scoped=true"
import script from "./MenuPrincipal.vue?vue&type=script&lang=js"
export * from "./MenuPrincipal.vue?vue&type=script&lang=js"
import style0 from "./MenuPrincipal.vue?vue&type=style&index=0&id=0e38861e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e38861e",
  null
  
)

export default component.exports